import { TranslationModule } from "../../translation/translation.module";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DetailPageComponent } from "./detail-page/detail-page.component";
import { BuyNowPageComponent } from "./buy-now-page/buy-now-page.component";
import { OrderConfirmationPageComponent } from "./order-confirmation-page/order-confirmation-page.component";
import { RouterModule } from "@angular/router";
import { ProductsRoutes } from "./products.routing";

import { NgxImageZoomModule } from "ngx-image-zoom";

import { GlobalModule } from "../../Global/global.module";
import { ProductListComponent } from "./product-list/product-list.component";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { PipesModule } from "../../shared/pipes/pipes.module";

import { ProductComponent } from "./products.component";
import { DirectiveModule } from "../../shared/Directives/directive.module";

import {
  BreadCrumpSetycoreComponent,
  ProductCatalogueSetycoreComponent,
  ProductDetailsSetycoreComponent,
  SnackbarComponent,
  AddProductPopupSetycoreComponent,
  BuyNowComponent,
  OrderConfirmationComponent,
} from "admin-common";

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    DetailPageComponent,
    ProductListComponent,
    ProductComponent,
    BuyNowPageComponent,
    OrderConfirmationPageComponent,
  ],
  imports: [
    TranslationModule,
    CommonModule,
    NgxImageZoomModule,
    RouterModule.forChild(ProductsRoutes),
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    DirectiveModule,
    ProductCatalogueSetycoreComponent,
    BreadCrumpSetycoreComponent,
    ProductDetailsSetycoreComponent,
    SnackbarComponent,
    AddProductPopupSetycoreComponent,
    BuyNowComponent,
    OrderConfirmationComponent,
  ],
})
export class ProductsModule {}
